import { jsx, jsxs } from "react/jsx-runtime";
import styled, { css } from "styled-components";
import { Tooltip } from "./Tooltip.js";
import { token } from "./token.js";
import { textStyles } from "./textStyles.js";
import { useTabsContext } from "./context8.js";
import { TruncatedText } from "./TruncatedText.js";
import { internalTokens } from "./themes.js";
function Tab({
  isActive = false,
  isLabelHidden = false,
  isDisabled = false,
  label,
  icon,
  onClick,
  ...props
}) {
  const {
    variant,
    shape
  } = useTabsContext();
  if (isLabelHidden) {
    return /* @__PURE__ */ jsx(Tooltip, {
      content: label,
      timing: "delay",
      children: (triggerProps) => /* @__PURE__ */ jsx(TabStyled, {
        "aria-label": label,
        onClick,
        $isActive: isActive,
        disabled: isDisabled,
        $variant: variant,
        $shape: shape,
        ...triggerProps,
        ...props,
        children: icon
      })
    });
  }
  return /* @__PURE__ */ jsxs(TabStyled, {
    "aria-label": label,
    onClick,
    $isActive: isActive,
    $variant: variant,
    $shape: shape,
    disabled: isDisabled,
    ...props,
    children: [icon && /* @__PURE__ */ jsx(Icon, {
      children: icon
    }), /* @__PURE__ */ jsx(TruncatedText, {
      children: label
    })]
  });
}
const TabStyled = styled.button.withConfig({
  displayName: "TabStyled",
  componentId: "sc-qpii5p-0"
})(["display:flex;flex-grow:1;flex-basis:0;justify-content:center;align-items:center;min-width:0;height:", ";padding:", " ", ";border:0;border-radius:", ";background-color:transparent;color:", ";font-family:inherit;text-align:center;cursor:pointer;", " &:disabled{color:", ";cursor:default;}&:focus-visible{color:", ";box-shadow:inset 0 0 0 2px ", ";outline:none;}", ";", ";"], (props) => props.$variant === "contained" ? "36px" : "40px", token.spacing3, token.spacing5, (props) => props.$shape === "pill" ? token.radiusPill : token.radiusBase, (props) => props.$isActive ? internalTokens["tabs-tab-color-active"] : internalTokens["tabs-tab-color"], textStyles.uiTextM, token.gray400, token.gray800, token.gray200, (props) => !props.$isActive && css(["&:hover:enabled{background-color:", ";color:", ";}"], token.gray25a, token.gray800), (props) => {
  if (props.$isActive) {
    if (props.$variant === "contained") {
      return css(["background-color:", ";box-shadow:0 0 1px ", ",", ";"], internalTokens["tabs-contained-tab-background-color-active"], token.colorShadow, token.elevation1);
    }
    if (props.$variant === "clean") {
      return css(["background-color:", ";"], token.gray50a);
    }
  }
});
const Icon = styled.span.withConfig({
  displayName: "Icon",
  componentId: "sc-qpii5p-1"
})(["margin-right:", ";"], token.spacing3);
export {
  Tab
};
//# sourceMappingURL=Tab.js.map
